import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { PaymentMethod } from 'app/shared/model/enumerations/payment-method.model';
import { BillingPeriod } from 'app/shared/model/enumerations/billing-period.model';
import { Currency } from 'app/shared/model/enumerations/currency.model';
import { createEntity, getEntity, reset, updateEntity } from './bank-account.reducer';

export const BankAccountUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const bankAccountEntity = useAppSelector(state => state.bankAccount.entity);
  const loading = useAppSelector(state => state.bankAccount.loading);
  const updating = useAppSelector(state => state.bankAccount.updating);
  const updateSuccess = useAppSelector(state => state.bankAccount.updateSuccess);
  const paymentMethodValues = Object.keys(PaymentMethod);
  const billingPeriodValues = Object.keys(BillingPeriod);
  const currencyValues = Object.keys(Currency);

  const handleClose = () => {
    navigate('/bank-account');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...bankAccountEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          paymentMethod: 'CREDITCARD',
          billingPeriod: 'YEARLY',
          currency: 'EU',
          ...bankAccountEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="crawlerBackendApp.bankAccount.home.createOrEditLabel" data-cy="BankAccountCreateUpdateHeading">
            <Translate contentKey="crawlerBackendApp.bankAccount.home.createOrEditLabel">
              Create or edit a BankAccount
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="bank-account-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.bankAccount.bankAccountNumber')}
                id="bank-account-bankAccountNumber"
                name="bankAccountNumber"
                data-cy="bankAccountNumber"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.bankAccount.bankAccountHolder')}
                id="bank-account-bankAccountHolder"
                name="bankAccountHolder"
                data-cy="bankAccountHolder"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.bankAccount.paymentMethod')}
                id="bank-account-paymentMethod"
                name="paymentMethod"
                data-cy="paymentMethod"
                type="select"
              >
                {paymentMethodValues.map(paymentMethod => (
                  <option value={paymentMethod} key={paymentMethod}>
                    {translate(`crawlerBackendApp.PaymentMethod.${paymentMethod}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.bankAccount.billingPeriod')}
                id="bank-account-billingPeriod"
                name="billingPeriod"
                data-cy="billingPeriod"
                type="select"
              >
                {billingPeriodValues.map(billingPeriod => (
                  <option value={billingPeriod} key={billingPeriod}>
                    {translate(`crawlerBackendApp.BillingPeriod.${billingPeriod}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.bankAccount.currency')}
                id="bank-account-currency"
                name="currency"
                data-cy="currency"
                type="select"
              >
                {currencyValues.map(currency => (
                  <option value={currency} key={currency}>
                    {translate(`crawlerBackendApp.Currency.${currency}`)}
                  </option>
                ))}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/bank-account"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BankAccountUpdate;
